import { MultiSelect } from "ui-components/Select";

import Columns from "./Columns";
import NoExistingData from "./No-Existing-Data";

import useFetchFiles from "./fetch-files";

interface Props {
  selected?: string[];
  onChange: (fileIds: string[]) => unknown;
  label?: React.ReactNode;
  name?: string;
  help?: React.ReactNode;
  showColumns?: boolean;
}

const SelectDataFiles = ({
  selected,
  onChange,
  label,
  name = "selectFile",
  help,
  showColumns,
}: Props) => {
  const { data, status } = useFetchFiles();

  if (status === "loading") {
    return null;
  }

  if (data.flat().length === 0) {
    return <NoExistingData />;
  }

  if (status === "success" && data.flat().length < 2) {
    return (
      <NoExistingData message="You need at least two data files in order to stack. You currently have only ONE data file on the platform!!!" />
    );
  }

  const dataListing = data.flat();

  const options = dataListing.map((d) => ({
    value: d.id,
    label: `${
      d.name || d.id
    } (${d.row_count.toLocaleString()} rows and ${d.col_count.toLocaleString()} columns. Created on ${new Date(
      d.created_time
    ).toDateString()})`,
  }));

  return (
    <div className="flex mt-2">
      {label && (
        <div className="w-1/4">
          <label htmlFor={name} className="font-bold">
            {label}
          </label>
        </div>
      )}

      <div className="w-full">
        <MultiSelect
          name={name}
          options={options}
          selected={selected || []}
          onChange={onChange}
          placeholder="Select a File"
          enableSelectAll={false}
        />
        {help && <div className="text-sm text-gray-700">{help}</div>}
        {showColumns &&
          (selected || []).map((f) => (
            <div key={f} className="py-1 my-1">
              <Columns
                selectedFile={dataListing.find((d) => d.id === f)}
                label={dataListing.find((d) => d.id === f)?.name}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default SelectDataFiles;
